import type {
  AgentDeploySip,
  AgentDeploySipBody,
  SipPreset,
} from "@/schemas/agent.schema";
import { api } from "@/services/api";

export const agentDeploySipApi = {
  getByAgentId: async (agentId: string) => {
    const { data } = await api.get<AgentDeploySip | { enable_inbound: false }>(
      `/agent-deploy-sip/${agentId}`
    );
    return data;
  },

  createOrUpdate: async (agentId: string, body: AgentDeploySipBody) => {
    const { data } = await api.put<AgentDeploySip>(`/agent-deploy-sip/${agentId}`, body);
    return data;
  },

  // Gerenciamento de presets
  getPresets: async (type?: "inbound" | "outbound") => {
    const params = type ? `?type=${type}` : "";
    const { data } = await api.get<SipPreset[]>(`/organization/sip-presets${params}`);
    return data;
  },

  createPreset: async (preset: Omit<SipPreset, "id" | "created_at">) => {
    const { data } = await api.post<SipPreset>("/organization/sip-presets", preset);
    return data;
  },

  getPresetById: async (presetId: string) => {
    const { data } = await api.get<SipPreset>(`/organization/sip-presets/${presetId}`);
    return data;
  },

  updatePreset: async (presetId: string, preset: Partial<SipPreset>) => {
    const { data } = await api.put<SipPreset>(`/organization/sip-presets/${presetId}`, preset);
    return data;
  },

  deletePreset: async (presetId: string) => {
    await api.delete(`/organization/sip-presets/${presetId}`);
  },

  getDefaultPreset: async (type: "inbound" | "outbound") => {
    const { data } = await api.get<SipPreset | null>(`/organization/sip-presets/default/${type}`);
    return data;
  },
};
